import { createAsyncThunk } from "@reduxjs/toolkit";
import { Region } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindRegion, GetRegion } from "../../region/api/interface";

export const findSelectRegion = createAsyncThunk(
  "selectRegion/findSelectRegion",
  async (values: FindRegion, { rejectWithValue }) => {
    try {
      const response = await Region.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectRegion = createAsyncThunk(
  "selectRegion/searchSelectRegion",
  async (values: FindRegion, { rejectWithValue }) => {
    try {
      const response = await Region.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectRegion = createAsyncThunk(
  'selectRegion/getSelectRegion',
  async ({ id }: GetRegion, { rejectWithValue }) => {
    try {
      const response = await Region.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
